import { defaultApiState } from '../api.state';

export const reviewState = {
  apiState: {
    getReviews: defaultApiState,
    approveReview: defaultApiState,
    rejectReview: defaultApiState,
  },
  reviews: [],
};
